import { sortBy } from 'lodash';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MultiSelectAutocompleteFilter from '../../../../Filters/MultiSelectAutocompleteFilter';
import { UserRolePermissions } from '../../../../../constants';
import checkIsAdmin from '../../../../../helpers/selectors/checkIsAdmin';

const BookedByFilter = ({ onSearch }) => {
  const { tripsSearch } = useSelector((store) => store.trip);
  const [allUsersFilter, setAllUsersFilter] = useState(null);
  const { travelAgency } = useSelector((store) => store.user);
  const isAdminUser = useSelector(checkIsAdmin);
  const doShowBookingAgent = travelAgency && travelAgency.permissions
  && travelAgency.permissions.authenticated && (travelAgency.permissions.authenticated
    .includes(UserRolePermissions.canViewOtherAgentsBookedTrips) || isAdminUser);
  const bookingAgentFilterLabel = travelAgency && travelAgency.filterSettings
  && travelAgency.filterSettings.bookingAgentFilterLabel;
  const formatAllUsers = useCallback((emails) => [{
    suggests: sortBy(emails
      .map((item) => ({
        value: item,
        label: item,
      })), ['label']),
    label: 'Users',
    value: 'Users',
  }], []);

  const handleChangeSelectedUsers = useCallback((selectedUsers) => {
    const searchObj = {
      ...tripsSearch.searchObj,
      selectedUsers,
      page: 1,
    };
    onSearch(searchObj);
  }, [onSearch, tripsSearch.searchObj]);

  useEffect(() => {
    if (tripsSearch.filterObj && tripsSearch.filterObj.allUsers) {
      setAllUsersFilter(formatAllUsers(tripsSearch.filterObj.allUsers));
    }
  }, [tripsSearch.filterObj, formatAllUsers]);

  return doShowBookingAgent && (allUsersFilter || []).length > 0 ? (
    <MultiSelectAutocompleteFilter
      onChange={handleChangeSelectedUsers}
      label={bookingAgentFilterLabel || 'Booking agent'}
      options={allUsersFilter || []}
      values={tripsSearch.searchObj.selectedUsers || []}
      filterMaxWidthClass="max-w-full"
      variant="outline"
    />
  ) : <></>;
};

BookedByFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
};
export default BookedByFilter;
